// import axios from 'axios'
import dayjs from 'dayjs'
import {
  getLateDriverDaily,
  queryHourlyLOTS,
  queryHourlyStat
} from '../customGraphql/queries'
// import { config } from '../setting/axiosConfig'
import { API, graphqlOperation } from 'aws-amplify'

const initialState = {
  store: [],
  branch: {},
  driver: {},
  lots: {},
  hrsStat: {},
  haveNoData: false
}

const summary = {
  namespaced: true,
  state: initialState,
  getters: {
    haveNoData: state => {
      return state.haveNoData
    },
    storeData: state => {
      return state.store
    },
    listBranch: state => {
      return state.branch
    },
    listDriver: state => {
      return state.driver
    },
    hourlyLOTS: state => {
      // late on-time success order per hour
      return state.lots
    },
    hourlyStat: state => {
      // late on-time success order per hour
      return state.hrsStat
    }
  },
  mutations: {
    clearStoreDetail (state) {
      state.store = []
    },
    setHourlyStat (state, value) {
      state.hrsStat = value
    },
    setHourlyLOTS (state, value) {
      state.lots = value
    },
    setHaveNoData (state, value) {
      state.haveNoData = value
    },
    setStoreDetail (state, value) {
      state.store = [...state.store, value]
    },
    sortedOnTimeByBranch (state) {
      const data = state.store
      const branch = {}
      data.forEach(item => {
        // const date = item.date
        item.driverList.forEach(i => {
          if (!branch[`${i.origin}`]) {
            branch[`${i.origin}`] = {}
            branch[`${i.origin}`].late = i.late
            branch[`${i.origin}`].onTime = i.notLate
            branch[`${i.origin}`].driver = []
            branch[`${i.origin}`].driver.push({
              driverName: i.driverName,
              late: i.late,
              onTime: i.notLate
            })
            branch[`${i.origin}`].count = 1
          } else {
            branch[`${i.origin}`].late += i.late
            branch[`${i.origin}`].onTime += i.notLate
            branch[`${i.origin}`].driver.push({
              driverName: i.driverName,
              late: i.late,
              onTime: i.notLate
            })
            branch[`${i.origin}`].count += 1
          }
        })
      })
      // console.log('branch', branch)
      state.branch = branch
    },
    sortedOnTimeByDriver (state) {
      const data = state.store
      const driver = {}
      data.forEach(item => {
        item.driverList.forEach(i => {
          if (!driver[`${i.driverName}`]) {
            driver[`${i.driverName}`] = {
              late: i.late,
              onTime: i.notLate,
              branch: i.origin,
              count: 1
            }
          } else {
            driver[`${i.driverName}`].late += i.late
            driver[`${i.driverName}`].onTime += i.notLate
            // driver[`${i.driverName}`].branch += i.origin
            driver[`${i.driverName}`].count += 1
          }
        })
      })
      // console.log('driver', driver)
      state.driver = driver
    }
  },
  actions: {
    async getHourlyStat (context, dateTime) {
      // const _config = { ...config }
      // _config.data = JSON.stringify({
      //   query: queryHourlyStat.replace('$dateTime', `"${dateTime}"`)
      // })
      // const { data } = await axios(_config)
      // // console.log('queryHourlyLOTS >>>', data)
      // const stats =
      //   data.data.getDateTimebyDateTime.items[0].statusesDaily.items
      const res = await API.graphql(graphqlOperation(queryHourlyStat.replace('$dateTime', `"${dateTime}"`)))
      // console.log('queryHourlyLOTS >>>', res.data)
      const stats = res.data.getDateTimebyDateTime.items[0].statusesDaily.items
      if (!stats) {
        return null
      }
      if (!stats.length) {
        context.commit('setHourlyStat', null)
      } else {
        context.commit('setHourlyStat', stats[0])
      }
    },
    async getHourlyLOTS (context, dateTime) {
      // const _config = { ...config }
      // _config.data = JSON.stringify({
      //   query: queryHourlyLOTS.replace('$date', `"${dateTime}"`)
      // })
      // const { data } = await axios(_config)
      // // console.log('queryHourlyLOTS >>>', data)
      // const lots = data.data.getDateTimebyDate.items
      const res = await API.graphql(graphqlOperation(queryHourlyLOTS.replace('$date', `"${dateTime}"`)))
      // console.log('queryHourlyLOTS >>>', res.data)
      const lots = res.data.getDateTimebyDate.items
      if (!lots) {
        return null
      }
      const hourlylots = lots.map(i => {
        if (!i.latesHour.items.length) {
          i.latesHour = { late: null, notLate: null }
        } else {
          i.latesHour = i.latesHour.items[0]
        }
        if (!i.statusesHour.items.length) {
          i.successOrderHour = null
        } else {
          i.successOrderHour = i.statusesHour.items[0].successOrder
        }
        delete i.statusesHour
        return i
      })
      // console.log('hourlylots>>>', hourlylots)
      context.commit('setHourlyLOTS', hourlylots)
    },
    async getStoreDetail (context, { timeframe }) {
      const startDate = timeframe[0]
      const diffDate = timeframe[1]
      try {
        for (let i = 0; i <= diffDate; i++) {
          let queryDate
          if (i === 0) {
            if (
              startDate.format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD')
            ) {
              queryDate = startDate
                .subtract(8, 'hours')
                .format('YYYY-MM-DDTHH:59:59[Z]')
            } else {
              queryDate = startDate.format('YYYY-MM-DD') + 'T16:59:59Z'
            }
          } else {
            queryDate =
              startDate.subtract(i, 'day').format('YYYY-MM-DD') + 'T16:59:59Z'
          }
          // const _config = { ...config }
          // _config.data = JSON.stringify({
          //   query: getLateDriverDaily.replace('$date', `"${queryDate}"`)
          // })
          // const { data } = await axios(_config)

          const data = await API.graphql(graphqlOperation(getLateDriverDaily.replace('$date', `"${queryDate}"`)))
          let lateCount = []
          let driverList = []
          if (
            !data.data.getDateTimebyDateTime.items[0].latesDaily.items.length
          ) {
            lateCount = []
            driverList = []
          } else {
            lateCount =
              data.data.getDateTimebyDateTime.items[0].latesDaily.items
            driverList =
              data.data.getDateTimebyDateTime.items[0].latesDriverDaily.items
          }
          const value = {
            date: queryDate.slice(0, 10),
            lateCount: lateCount,
            driverList: driverList
          }
          console.log('queryDate', queryDate)
          if (value.lateCount.length === 0 || value.driverList.length === 0) {
            context.commit('clearStoreDetail')
            context.commit('setHaveNoData', true)
            console.log('setHaveNoData', true)
            return
          } else {
            context.commit('setStoreDetail', value)
          }
        }
        context.commit('sortedOnTimeByBranch')
        context.commit('sortedOnTimeByDriver')
        context.commit('setHaveNoData', false)
        console.log('setHaveNoData', false)
      } catch (error) {
        console.log('error', error)
        context.commit('clearStoreDetail')
        context.commit('setHaveNoData', true)
        console.log('setHaveNoData', true)
      }
    }
  }
}

export default summary
